import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {tap} from 'rxjs/operators';
import {Serializer, SerializerResponse, Serializers} from '../interfaces/serializer';
import {SavedReport} from '../interfaces/saved-reports';
import {AppService} from './app.service';
import {SerializerUtils} from '../libraries/serializer-utils';

@Injectable({
  providedIn: 'root'
})
export class SavedReportsService {

  constructor(
    private readonly _http: HttpClient,
    private readonly _appS: AppService,
  ) {}

  public getSavedReports(parameters: boolean): Observable<SerializerResponse<Serializers<SavedReport>>> {
    return this._http.get<any>(`${environment.baseUrl}/api/${this._appS.datasetID}/reports`, {
      params: {
        parameters: parameters ? 'true' : 'false'
      }
    })
      .pipe(
        tap((savedReports: SerializerResponse<Serializers<SavedReport>>): void => {
          SerializerUtils.joinRelationships(savedReports, ['user']);
        })
      );
  }

  public getSavedReport(id: number): Observable<SerializerResponse<Serializer<SavedReport>>> {
    return this._http.get<any>(`${environment.baseUrl}/api/${this._appS.datasetID}/reports/${id}`);
  }

  public updateReport(report: Serializer<SavedReport>, update: Partial<SavedReport>): void {}

  public deleteReport(report: Serializer<SavedReport>): Observable<any> {
    return this._http.delete(`${environment.baseUrl}/api/${this._appS.datasetID}/reports/${report.id}`);
  }

  public public(report: Serializer<SavedReport>, isPublic: boolean, password: string): Observable<SerializerResponse<Serializer<SavedReport>>> {
    return this._http.post<SerializerResponse<Serializer<SavedReport>>>(`${environment.baseUrl}/api/${this._appS.datasetID}/reports/${report.id}/public`, {
      is_public: isPublic,
      password: password
    });
  }

  public favorite(report: Serializer<SavedReport>, is_favorite: boolean): Observable<SerializerResponse<Serializer<SavedReport>>> {
    return this._http.post<SerializerResponse<Serializer<SavedReport>>>(`${environment.baseUrl}/api/${this._appS.datasetID}/reports/${report.id}/favorite`, {
      is_favorite: is_favorite
    });
  }

}
